import React from "react";
import '../DeepSeekandAquaBodies/DeepSea.css';

const DeepSea = () => {
  return (
    <div className="deepseek-container">
      <h1 className="deepseek-title">Deep-Sea Plastic Detection & AquaLife Protection</h1>
      
      <section className="deepseek-section">
        <h2>Introduction</h2>
        <p>
          Plastic pollution is one of the most pressing environmental crises, particularly in South Asia’s rivers, seas, and coastal regions. With millions of tons of plastic waste entering water bodies annually, marine ecosystems are being severely impacted, affecting biodiversity, local economies, and human health. Traditional cleanup efforts are slow, expensive, and reactive. To combat this, we propose AquaGuardAI, an AI-powered deep-sea plastic detection and tracking system that offers real-time monitoring and predictive analytics to drive large-scale, data-driven conservation efforts.
        </p>
      </section>

      <section className="deepseek-section">
      <h2>Scope of the Problem</h2>
        <ul>
          <li><strong>Plastic Waste Accumulation:</strong> Rivers act as major conduits, transporting plastic from urban areas into the ocean, where they accumulate in fragile ecosystems like coral reefs and fisheries.</li>
          <li><strong>Limited Monitoring & Tracking:</strong> The deep-sea environment remains largely unmonitored due to visibility issues, high costs, and logistical challenges.</li>
          <li><strong>Delayed Cleanup Efforts:</strong> Without real-time data, authorities struggle to locate and remove plastic efficiently. Most cleanup efforts rely on surface-level collection, leaving deep-sea pollution unaddressed.</li>
          <li><strong>Lack of Public Awareness & Engagement:</strong> Many communities unknowingly contribute to plastic pollution due to limited education on proper waste disposal and its long-term consequences.</li>
        </ul>
      </section>

      <section className="deepseek-section">
        <h2>Target Beneficiaries</h2>
        <table className="deepseek-table">
          <thead>
            <tr>
              <th>Affected Group</th>
              <th>Impact of Plastic Pollution</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Marine Life</td>
              <td>Entanglement and ingestion cause injuries, suffocation, and death.</td>
            </tr>
            <tr>
              <td>Tourism Industry</td>
              <td>Polluted beaches deter eco-tourism, reducing revenues.</td>
            </tr>
            <tr>
              <td>Governments & Conservation Groups</td>
              <td>Limited data hinders effective policies and cleanup efforts.</td>
            </tr>
          </tbody>
        </table>
      </section>

      <section className="deepseek-section">
        <h2>Environmental & Social Impact</h2>
        <ul>
          <li><strong>Biodiversity Protection:</strong> Early detection prevents damage to marine species.</li>
          <li><strong>Reduction in Microplastics:</strong> Preventing degradation reduces seafood contamination.</li>
          <li><strong>Economic Benefits:</strong> Sustains fishing, tourism, and lowers cleanup costs.</li>
          <li><strong>Community Involvement:</strong> Encourages local engagement in conservation.</li>
        </ul>
      </section>

      <section className="deepseek-section">
  <h2>Team Members</h2>
  <table className="deepseek-table">
    <thead>
      <tr>
        <th>Name</th>
        <th>Role</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>Syed Shah Hussain Badshah</td>
        <td>Team Lead / Software Engineer / Researcher</td>
      </tr>
      <tr>
        <td>Syed Atif Shah</td>
        <td>Software Engineer</td>
      </tr>
    </tbody>
  </table>
</section>


      <section className="deepseek-section">
        <h2>Thematic Areas</h2>
        <ul>
          <li><strong>Marine Conservation & Biodiversity Protection:</strong> Prevents further loss of marine species and habitats.</li>
          <li><strong>Sustainable Development & Blue Economy:</strong> Enhances economic stability for coastal communities reliant on fishing and tourism.</li>
          <li><strong>Smart Environmental Monitoring:</strong> Leverages AI, IoT, and drones to create an efficient, data-driven conservation system.</li>
          <li><strong>Public Awareness & Policy Influence:</strong> Enables governments and NGOs to make informed decisions using real-time data analytics.</li>
        </ul>
      </section>

      <section className="deepseek-section">
        <h2>Proposed Innovative Solution: AquaGuardAI</h2>
        <h3>What is AquaGuardAI?</h3>
        <p>
          AquaGuardAI is a real-time, AI-powered deep-sea plastic detection and tracking system that integrates autonomous underwater drones, machine learning, and cloud-based analytics to map and predict plastic waste accumulation in oceans and rivers.
        </p>
        <h3>How It Works</h3>
        <ul>
          <li><strong>Underwater Plastic Detection & Classification:</strong> AI-powered drones equipped with high-resolution cameras and multispectral sensors scan ocean floors and riverbeds for plastic waste.</li>
          <li><strong>Real-Time Monitoring & Predictive Analytics:</strong> A live dashboard provides interactive pollution heatmaps, showing high-risk areas.</li>
          <li><strong>Community Engagement & Awareness:</strong> A mobile app enables users to report plastic pollution hotspots.</li>
        </ul>
      </section>

      <section className="deepseek-section">
        <h2>Why This is Innovative & Scalable</h2>
        <ul>
          <li>First-of-its-Kind AI-Powered Deep-Sea Plastic Detection System</li>
          <li>Scalable Across South Asia & Beyond – adaptable for global marine environments</li>
          <li>Faster, Cost-Effective, and More Accurate than traditional plastic monitoring methods</li>
          <li>Bridges the Gap Between Technology & Conservation Efforts</li>
          <li>Empowers Local Communities & Policy-Makers with Data-Driven Insights</li>
        </ul>
      </section>

      <section className="deepseek-section">
        <h2>Conclusion</h2>
        <p>
          AquaGuardAI is more than just a technological solution; it’s a scalable, data-driven approach to combating one of the greatest environmental challenges of our time. By integrating AI, real-time monitoring, and community engagement, we can take proactive steps toward protecting marine biodiversity, preserving livelihoods, and promoting global ocean health.
        </p>
      </section>
    </div>
  );
};

export default DeepSea;
